import { defineMessages } from 'react-intl';

import { MOODS } from './constants';

export default defineMessages<MOODS>({
  [MOODS.POSITIVE]: {
    defaultMessage: 'Positif',
  },

  [MOODS.NEUTRAL]: {
    defaultMessage: 'Neutre',
  },

  [MOODS.NEGATIVE]: {
    defaultMessage: 'Négatif',
  },
} as const);
